import React from 'react';
import useTariffUpload from '../../hooks/useTariffUpload';
import GeneralMessage from '../../components/UI/GeneralMessage';
import TariffUploadForm from '../../modules/tariff/TariffUploadForm';
import TariffContentList from '../../modules/tariff/TariffContentList';

const Tariff = props => {
    const {
        control,
        spinner,
        uploadHandler,
        tariffGridData,
        tariffGridHeaders,
        successMessage,
        generalErrorList,
    } = useTariffUpload();

    return (
        <>
            <GeneralMessage
                className="c-msg"
                successMessage={successMessage}
                errorList={generalErrorList}
            />
            <TariffUploadForm
                control={control}
                spinner={spinner}
                uploadHandler={uploadHandler}
                successMessage={successMessage}
                generalErrorList={generalErrorList}
            />
            <TariffContentList
                listTitle="Approved Tariff"
                gridHeaders={tariffGridHeaders}
                gridData={tariffGridData}
                hover={true}
            />
        </>
    );
};

export default Tariff;
